import { PaymentMethods } from "../pages/AiBuilderPage/AIBuilderPageInterface";
import { Currency, formatCurrencyInterface } from "./utilsInterface";
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// export function buildDescription(
//   formData: FormData,
//   cashOnDelivery: string,
//   onlinePayment: string,
//   price: string
// ) {
//   const productName = formData.productName || "Nombre no especificado";
//   const description = formData.description || "Descripción no disponible";
//   const cost = formData.cost || "Categorías no especificadas";

//   const paymentMethods = [cashOnDelivery, onlinePayment]
//     .filter((method) => method !== "")
//     .join(" y/o ");

//   return `Nombre del producto: ${productName}, información general del producto: ${description}, categorías principales: ${cost}, métodos de pago: ${paymentMethods}, el precio del producto es: ${price}`;
// }

export function getPaymentMethod(paymentMethods: PaymentMethods) {
  const cashOnDelivery = paymentMethods.cashOnDelivery
    ? "Pago contra entrega"
    : "";
  const onlinePayment = paymentMethods.onlinePayment ? "Pago en línea" : "";
  return { cashOnDelivery, onlinePayment };
}

// export function getPriceDetails(formData: FormData) {
//   if (formData.price && formData.currency) {
//     return formData.currency + " $" + formData.price;
//   }
//   return "";
// }

export function decodeBase64ToEmail(encodedEmail: string): string {
  return decodeURIComponent(atob(encodedEmail));
}

export function formatCurrency({
  currency = Currency.USD,
  amount,
}: formatCurrencyInterface): string {
  return new Intl.NumberFormat(currency.locale, {
    style: "currency",
    currency: currency.code,
    currencyDisplay: "code",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
    .format(amount)
    .replace(currency.code, "")
    .trim();
}

// const formatCurrency = (amount: number): string => {
//   return new Intl.NumberFormat("es-CO", {
//     style: "currency",
//     currency: "COP",

//   }).format(amount)
// }


export const truncateText = (text: string, maxLength: number = 90): string => {
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};


export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function toBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
  });
}